'use client';

import { Button } from '@petsmart-ui/sparky';
import { useEffect, useState } from 'react';

import { useDecisions, useDeviceType } from '@libs/common-next';

import { useProduct } from '@/entities/product';
import { dataLayerPush } from '@/shared/analytics';

import './BackToTopButton.scss';

export function BackToTopButton() {
    const [showButton, setShowButton] = useState(false);
    const mobileStickyATCFlag = useDecisions('m_sticky_cta');
    const { product } = useProduct();
    const { deviceType } = useDeviceType();
    const isMobileStickyPermanentCTA =
        (mobileStickyATCFlag === 'var1' || mobileStickyATCFlag === 'var2') &&
        deviceType === 'mobile' &&
        !product?.personalization;

    useEffect(() => {
        const handleScroll = () => {
            const { scrollY } = window;
            const viewportHeight = window.innerHeight;

            setShowButton(scrollY > viewportHeight);
        };
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        dataLayerPush({
            event: 'nav_click',
            nav_section: 'back to top',
            selection: 'top',
        });
    };

    if (!showButton) {
        return null;
    }

    return (
        <Button
            data-testid="back-to-top-button-test"
            className={`${isMobileStickyPermanentCTA ? 'back-to-top-button-optimizely--hidden' : ''} back-to-top-button`}
            text="Back to top button"
            iconName="chevron-up"
            hideText
            iconSize="lg"
            onClick={scrollToTop}
            variant="primary"
        />
    );
}
